export const journeyTag = 'Demat';
export const productCategory = 'investment';
export const propertyType = 'plp';
export const subSection = 'stock news - trading mall';
export const campaignName = 'DPAOP3|Mar';
export const sprint = 'DPAOP3|Mar';
export const referenceId = 'news';
export const segmentName = 'stock listing';
export const otherNewsEntryPoint = 'other_news';

/** Stock news CT DLS — shared GA / component click */
export const gaEventTypeClick = 'click';

/** `drawer_content_drawer` */
export const drawerContentDrawerComponentName = 'drawer_content_drawer';
export const drawerContentDrawerButtonClickEventType =
  'drawer_content_drawer_button_click';
export const drawerContentDrawerIconClickEventType =
  'drawer_content_drawer_icon_click';
export const selectStockDrawerCustAttribute1 = 'select_stock_drawer';

/** BFSL authentication consent modal — `EP_REFERENCE_ID` / `EP_CUST_ATTRIBUTE_1` */
export const authenticationConsentDrawerComponentId =
  'authentication_consent_drawer';
export const authenticationConsentDrawerSectionTitle =
  'Redirecting you to Bajaj Financial Securities Limited';
/** CT DLS `EP_CTA_TEXT` for `drawer_content_drawer_icon_click` */
export const authenticationConsentCrossIconCtaText = 'Cross icon';
export const authenticationConsentCrossIconInteraction = 'cross_icon';
export const authenticationConsentDrawerInteractionButton = 'button';

export const tickerStripDisplayBannerComponentName =
  'ticker_strip_display_banner';
export const tickerStripDisplayBannerButtonClickEventType =
  'ticker_strip_display_banner_button_click';
export const tickerStripDisplayBannerIconClickEventType =
  'ticker_strip_display_banner_icon_click';
export const tickerStripDefaultSectionTitle =
  'Start your trading journey with Bajaj Broking';
export const tickerStripFloatingStripCustAttribute1 = 'floating_strip';
export const tickerStripSubSectionOpenDematAccount = 'open demat account';
export const tickerStripSubSectionCrossIcon = 'cross icon';

export const ctaGroupCtaComponentName = 'cta_group_cta';
export const ctaGroupCtaButtonClickEventType = 'cta_group_cta_button_click';
export const ctaGroupPropertyTypePdp = 'pdp';
export const ctaGroupSrNumber = '1';
export const ctaGroupFullNewsGroupCustAttribute1 = 'full_news_group_cta';

export const masterCtaButtonFloatingComponentName =
  'master_cta_button_floating';
export const masterCtaButtonFloatingButtonClickEventType =
  'master_cta_button_floating_button_click';
export const masterCtaFloatingCustAttribute1 = 'floating_cta';

// Placeholder image URL for news items without images
export const PLACEHOLDER_IMAGE = 'https://cms-assets.bajajfinserv.in/is/image/bajajfinance/news-placeholder';
